import { Button, IconButton, ownerWindow, Tooltip } from '@material-ui/core'
import { useFormik } from 'formik'
import React, { useState, useContext, useEffect } from 'react'
import CustomPopover from '../../../custom/components/atoms/Popover'
import FormDialog from '../../../custom/components/organisms/Dialog'
import { mapData, calculateAge } from '../../../product/common/components'
import PrimaryButton from '../../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../../product/components/atoms/SecondaryButton'
import ProductCommonContext from '../../../product/context/common/commonContext'
import * as Yup from 'yup'
import UserContext from '../../../product/context/user/userContext'
import AlertContext from '../../../product/context/alert/alertContext'
import NorthCapitalContext from '../../../product/context/payment/northcapital/northcapitalContext'
import CustomDialog from '../../../product/components/organisms/Dialog/index'
import Cryptos from '../../../product/common/cryptos'

const OwnerDetails = (props) => {
    const [verified, setVerified] = useState(true)
    const [addNew, setAddNew] = useState(false)
    const productCommonContext = useContext(ProductCommonContext)
    const { static_page, getStaticPage, allCountries, allStates } = productCommonContext
    const userContext = useContext(UserContext)
    const {
        addCompanyOwner,
        updateCompanyOwner,
        removeCompanyOwner,
        getCompanyOwners,
        responseStatus: responseStatusUser,
    } = userContext

    const {
        uploadEntityDocument,
        uploadPartyDocument,
        responseStatus: responseStatusNorthCapitalsMoreStep,
        getuploadPartyDocument,
        party_owner_documents,
    } = useContext(NorthCapitalContext)

    const [ownersList, setOwnersList] = useState([])
    const [tmpOwnersList, setTmpOwnersList] = useState([])
    const [addingOwner, setAddingOwner] = useState(false)
    const [ownersChanged, setOwnersChanged] = useState(false)
    const [circle, setCircle] = useState({})
    const [disableBtn, setDisableBtn] = useState(false)

    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext

    const termformik = useFormik({
        initialValues: {
            termCheck: 0,
        },
    })

    const [confirmDeleteOwner, setConfirmDeleteOwner] = useState(false)
    const [activeOwner, setActiveOwner] = useState([])
    const [phoneError, setPhoneError] = useState(false)

    const [partyDocumentLoaded, setPartyDocumentLoaded] = useState(false)

    const validationArray = [
        Yup.object({
            //domesticYN: Yup.string().required('Required!'),
            domicile: Yup.string().required('Required!'),
            email: Yup.string()
                .email('Invalid email format')
                .max(250, 'Maximum 250 characters')
                .required('Required!'),
            address1: Yup.string()
                .trim()
                .matches(/^[0-9a-zA-Z- ,.#()]*$/g, 'Some kind of special characters not allowed')
                .max(250, 'Maximum 250 characters')
                .required('Required!'),
            /* address2: Yup.string()
                .trim()
                .matches(/^[0-9a-zA-Z- ,.#()]*$/g, 'Some kind of special characters not allowed')
                .max(250, 'Maximum 250 characters')
                .required('Required!'), */
            phone: Yup.string()
                .trim()
                .matches(/^[0-9- +()]*$/g, 'The number only')
                .max(20, 'Maximum 20 characters'),
            //.required('Required!'),
            city: Yup.string()
                .trim()
                .matches(/^[0-9a-zA-Z ]*$/g, 'The characters only')
                .required('Required!'),
            state: Yup.string().when(['country'], {
                is: (val) => val == 'US' || val == 'CA',
                then: Yup.string().trim().required('Required!'),
                otherwise: Yup.string().trim().nullable(),
            }),
            //state: Yup.string().trim().required('Required!'),
            first_name: Yup.string()
                .trim()
                .matches(/^[0-9a-zA-Z ]*$/g, 'Some kind of special characters not allowed')
                .max(250, 'Maximum 250 characters')
                .required('Required!'),
            last_name: Yup.string()
                .trim()
                .matches(/^[0-9a-zA-Z ]*$/g, 'Some kind of special characters not allowed')
                .max(250, 'Maximum 250 characters')
                .required('Required!'),
            dob: Yup.string().required('Required!'),
            //ssn: Yup.string().required('Required!'),
            ssn: Yup.string()
                .nullable(true)
                .when(['domicile'], {
                    is: (domicile) => domicile === 'non-resident',
                    then: Yup.string(),
                    otherwise: Yup.string()
                        .required('Required!')
                        .test(
                            'len',
                            '9 characters required',
                            (value) =>
                                value && value.replace(/_/g, '').replace(/-/g, '').length === 9,
                        ),
                }),
            /* userfile0: Yup.array().when('kyc_check_failed', {
                is: (kyc_check_failed) => kyc_check_failed >= 2,
                then: Yup.array().required('Required!'),
            }),
            docType: Yup.string().when('kyc_check_failed', {
                is: (kyc_check_failed) => kyc_check_failed >= 2,
                then: Yup.array().required('Required!'),
            }), */
            country: Yup.string().trim().required('Required!'),
            zip: Yup.string()
                .trim()
                .max(7, 'Maximum 7 characters Required!')
                .min(3, 'Minimum 3 characters Required!')
                .required('Required!'),
        }),
    ]

    const folderName = 'northcapital'

    const formik = useFormik({
        initialValues: {
            //termCheck: 0,
            first_name: '',
            last_name: '',
            email: '',
            phone: '+1',
            dob: '',
            ssn: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            id: '',
            kyc_check_failed: 0,
            kyc_check_clicked: 0,
            edited: 1,
            unsavedID: '',
            country: 'US',
            zip: '',
            verified: false,
            domesticYN: '',
            domicile: '',
            isDocumentUploaded: 0,
        },
        validationSchema: validationArray[0],
        onSubmit: (values) => {
            //setAddingOwner(true)
            //addCompanyOwner(values)
            //console.log(values)

            let formError = false
            if (calculateAge(values.dob) < 18) {
                setAlert('Age must be 18+', 'error')
                return false
            }
            if (values.ssn && values.domicile !== 'non-resident') {
                let regex = /^\d{9}$/
                if (!regex.test(values.ssn)) {
                    setAlert('Please enter valid ssn', 'error')
                    return false
                }
            }
            let tmpOwnersList = JSON.parse(JSON.stringify(ownersList))
            values.edited = values.verified ? 0 : 1

            values.state = values.country != 'US' ? 'NOUS' : values.state

            /* if (values.ssn) {
                values.ssn = Cryptos.encrypt(values.ssn)
            } */

            if (values.id) {
                let existingOwner = tmpOwnersList.filter((tmp) => {
                    return (
                        tmp.id != values.id &&
                        tmp.first_name.toLowerCase() == values.first_name.toLowerCase() &&
                        tmp.last_name.toLowerCase() == values.last_name.toLowerCase() &&
                        tmp.email.toLowerCase() == values.email.toLowerCase()
                    )
                })

                if (existingOwner.length > 0) {
                    setAlert('You have already added this owner.', 'error')
                    formError = true
                } else {
                    tmpOwnersList.map((item, index) => {
                        if (item.id == values.id) {
                            tmpOwnersList[index].email = values.email
                            tmpOwnersList[index].first_name = values.first_name
                            tmpOwnersList[index].last_name = values.last_name
                            tmpOwnersList[index].phone = values.phone
                            tmpOwnersList[index].dob = values.dob
                            tmpOwnersList[index].ssn = values.ssn
                            tmpOwnersList[index].address1 = values.address1
                            tmpOwnersList[index].address2 = values.address2
                            tmpOwnersList[index].city = values.city
                            tmpOwnersList[index].state = values.state
                            tmpOwnersList[index].country = values.country
                            tmpOwnersList[index].zip = values.zip
                            tmpOwnersList[index].edited = 1
                            tmpOwnersList[index].domesticYN = values.domesticYN
                            tmpOwnersList[index].domicile = values.domicile

                            if (
                                values.kyc_check_failed >= 2 ||
                                (values.domicile == 'non-resident' &&
                                    values.isDocumentUploaded === 0)
                            ) {
                                if (documentFormik.values.userfile.length <= 0) {
                                    formError = true
                                    setAlert('Please upload a document', 'error')
                                } else if (!documentFormik.values.document_type) {
                                    formError = true
                                    setAlert('Please select a document type', 'error')
                                } else {
                                    let doc_title =
                                        escape(documentFormik.values.document_type) + ' Document'
                                    let obj = {
                                        documentTitle: doc_title,
                                        userfile: documentFormik.values.userfile,
                                        attachFolder: folderName,
                                        documentType: documentFormik.values.document_type,
                                    }

                                    /*  tmpOwnersList[index].documents = {
                                        documents: [obj],
                                        id: formik.values.id,
                                        isOwner: 1,
                                    } */
                                    //values.first_name + ' ' + values.last_name +' Documents'
                                    documentFormik.setFieldValue('documentTitle', doc_title)
                                    tmpOwnersList[index].documents = {
                                        documentTitle: doc_title,
                                        userfile: documentFormik.values.userfile,
                                        attachFolder: folderName,
                                        documentType: documentFormik.values.document_type,
                                        id: formik.values.id,
                                        isOwner: 1,
                                    }

                                    //documents.push(obj)

                                    //}

                                    //uploadEntityDocument({ documents: documents, id: formik.values.id, isOwner: 1 })
                                    //entityDocumentFormik.handleSubmit()
                                }
                            }
                        }
                    })
                }
            } else {
                if (ownersList.length < 6) {
                    let foundUnsaved = false
                    let existingOwner = tmpOwnersList.filter((tmp) => {
                        return (
                            tmp.first_name.toLowerCase() == values.first_name.toLowerCase() &&
                            tmp.last_name.toLowerCase() == values.last_name.toLowerCase() &&
                            tmp.email.toLowerCase() == values.email.toLowerCase()
                        )
                    })

                    if (existingOwner.length > 0) {
                        setAlert('You have already added this owner.', 'error')
                        formError = true
                    } else {
                        let newIndex = 0
                        tmpOwnersList.map((item, index) => {
                            if (item.unsavedID == values.unsavedID) {
                                tmpOwnersList[index] = values
                                foundUnsaved = true
                                newIndex = index
                            }
                        })

                        if (!foundUnsaved) {
                            values.unsavedID = 'new-' + ownersList.length
                            tmpOwnersList.push(values)
                            newIndex = tmpOwnersList.length - 1
                        }

                        if (values.domicile == 'non-resident' && values.isDocumentUploaded === 0) {
                            if (documentFormik.values.userfile.length <= 0) {
                                formError = true
                                setAlert('Please upload a document', 'error')
                            } else if (!documentFormik.values.document_type) {
                                formError = true
                                setAlert('Please select a document type', 'error')
                            } else {
                                let doc_title =
                                    escape(documentFormik.values.document_type) + ' Document'
                                let obj = {
                                    documentTitle: doc_title,
                                    userfile: documentFormik.values.userfile,
                                    attachFolder: folderName,
                                    documentType: documentFormik.values.document_type,
                                }

                                documentFormik.setFieldValue('documentTitle', doc_title)
                                tmpOwnersList[newIndex].documents = {
                                    documentTitle: doc_title,
                                    userfile: documentFormik.values.userfile,
                                    attachFolder: folderName,
                                    documentType: documentFormik.values.document_type,
                                    id: formik.values.id,
                                    isOwner: 1,
                                }
                            }
                        }
                    }
                } else {
                    setAlert('You can add upto 5 owners only.', 'error')
                }
            }

            if (!formError) {
                //setOwnersList({})
                // if (phoneError) {
                //     setAlert('Invalid mobile number / country code', 'error')
                // } else {
                setOwnersList(tmpOwnersList)
                setAddNew(false)
                // }
            }
        },
    })

    const errorFunc = (data) => {
        setPhoneError(data)
    }

    const checkbox = [
        {
            label: 'I hereby certify that the information provided for Wayne Enterprises Controller and Beneficial Owners is complete and correct',
            name: 'termCheck',
            type: 'checkbox',
            class: 'col-12 mt-1 chkBoxWrpr',
            formik: termformik,
            disabled: !ownersChanged,
        },
    ]

    const addOwner = [
        /* {
            title: <span className="cursorDecoy">Account Type</span>,
            type: 'radio',
            name: 'domesticYN',
            class: 'col-12 mb-2',
            item: [
                { id: 'domestic_account', description: 'Domestic (US)' },
                { id: 'international_account', description: 'International' },
            ],
            formik: formik,
        }, */
        {
            /* title: [
                <Tooltip title="Are you a US Resident?" arrow={true} placement="top">
                    <span className="cursorDecoy">Domicile</span>
                </Tooltip>,
            ], */
            title: <span className="cursorDecoy">Domicile</span>,
            type: 'radio',
            name: 'domicile',
            class: 'col-12 mb-2',
            item: [
                { id: 'U.S. Citizen', description: 'U.S. Citizen' },
                { id: 'U.S. Resident', description: 'U.S. Resident' },
                { id: 'non-resident', description: 'Non US Resident' },
            ],
            formik: formik,
            disabled: formik.values.verified,
        },
        {
            label: 'First Name',
            name: 'first_name',
            type: 'text',
            placeholder: 'Enter your first name',
            class: `col-12 col-sm-6`,
            // autoFocus: true,
            formik: formik,
            upperLabel: true,
            disabled: formik.values.verified,
        },
        {
            label: 'Last Name',
            name: 'last_name',
            type: 'text',
            placeholder: 'Enter your last name',
            class: `col-12 col-sm-6`,
            formik: formik,
            upperLabel: true,
            disabled: formik.values.verified,
        },
        {
            label: 'Email Address',
            name: 'email',
            type: 'email',
            placeholder: 'Enter your email address',
            class: 'col-12 col-sm-6',
            formik: formik,
            upperLabel: true,
        },
        {
            label: 'Mobile Number',
            name: 'phone',
            type: 'phone',
            placeholder: 'Mobile number',
            class: 'col-12 col-sm-6',
            formik: formik,
            // onError: errorFunc,
            displayFlag: true,
            upperLabel: true,
            countryCodeEditable: false,
        },
        {
            label: 'Date of Birth',
            name: 'dob',
            type: 'date',
            placeholder: 'MM-DD-YYYY',
            class: `col-12 col-sm-6 d-flex flex-column`,
            disableFuture: true,
            formik: formik,
            helperText: (
                <CustomPopover
                    label="You must be 18 years old to register"
                    content="Since we will be paying you royalties, minimul age is 18+."
                />
            ),
            upperLabel: true,
            disabled: formik.values.verified,
        },
        {
            //label: 'Controller SSN',
            label: 'SSN',
            name: 'ssn',
            type: 'text',
            placeholder: 'Enter SSN',
            class: `col-12 col-sm-6 ssnFld  ${
                formik.values.domicile === 'non-resident' ? 'd-none' : ''
            }`,
            disableFuture: true,
            formik: formik,
            type: 'hiddenMask',
            maskValue: '***-**-****',
            upperLabel: true,
            disabled: formik.values.verified,
        },
        {
            label: 'Address Line 1',
            name: 'address1',
            type: 'text',
            placeholder: 'Enter your address',
            class: 'col-12 col-sm-6',
            formik: formik,
            upperLabel: true,
            disabled: formik.values.verified,
        },
        {
            label: 'Address Line 2',
            name: 'address2',
            type: 'text',
            placeholder: 'Enter your address',
            class: 'col-12 col-sm-6',
            formik: formik,
            upperLabel: true,
            disabled: formik.values.verified,
        },
        {
            label: 'City',
            name: 'city',
            type: 'text',
            placeholder: 'Enter your city',
            class: 'col-12 col-sm-6',
            formik: formik,
            upperLabel: true,
            disabled: formik.values.verified,
        },
        {
            label: 'State',
            placeholder: 'Select your state',
            class: `col-12 col-sm-6${
                formik.values.country != '' &&
                formik.values.country != 'US' &&
                formik.values.country != 'CA'
                    ? ' d-none'
                    : ''
            }`,
            type: 'select',
            options: allStates
                .filter(
                    (state) =>
                        (formik.values.country
                            ? formik.values.country.indexOf(state.countryCode) !== -1
                            : global.defaultCountry.indexOf(state.countryCode) !== -1) &&
                        global.ignoreStates.indexOf(state.isoCode) === -1,
                )
                .map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.name
                    busCategoryChanged.value = buscat.isoCode
                    return busCategoryChanged
                }),
            name: 'state',
            formik: formik,
            upperLabel: true,
            disabled: formik.values.verified,
        },
        {
            label: 'Country',
            placeholder: 'Select your country',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allCountries
                .filter((country) => global.ignoreCountry.indexOf(country.isoCode) === -1)
                .map((country) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = country.name
                    busCategoryChanged.value = country.isoCode
                    return busCategoryChanged
                }),
            name: 'country',
            formik: formik,
            upperLabel: true,
            disabled: formik.values.verified,
        },
        {
            label: 'Zip code',
            placeholder: 'Enter your zip code',
            class: 'col-12 col-sm-6',
            type: 'text',
            name: 'zip',
            formik: formik,
            upperLabel: true,
            disabled: formik.values.verified,
        },
    ]

    const validationDoc = Yup.object({
        documentTitle: Yup.string(),
        userfile: Yup.array().required('Required!'),
    })

    const documentFormik = useFormik({
        initialValues: {
            documentTitle: '',
            userfile: [],
            attachFolder: folderName,
        },
        validationSchema: validationDoc,
        onSubmit: (values) => {
            uploadPartyDocument(values)
        },
    })

    const validationEnDoc = Yup.object({
        userfile0: Yup.array().required('Required!'),
        /* userfile1: Yup.array().required('Required!'),
        userfile2: Yup.array().required('Required!'),
        userfile3: Yup.array().required('Required!'), */
    })

    const entityDocumentFormik = useFormik({
        initialValues: {
            documentTitle: '',
            userfile0: [],
            userfile1: [],
            userfile2: [],
            userfile3: [],
            attachFolder: folderName,
        },
        //validationSchema: validationEnDoc,
        onSubmit: (values) => {
            //let entityName = user.entityName ? user.entityName : 'NewEntity'
            let entityName = 'NewEntity'
            let documents = []

            //for (let i = 0; i < 4; i++) {
            let obj = {
                documentTitle: entityName + ' Documents',
                userfile: values[`userfile0`], //values[`userfile${i}`],
                attachFolder: folderName,
                id: formik.values.id,
                isOwner: 1,
            }
            documents.push(obj)
            //}

            uploadEntityDocument({ documents: documents, id: formik.values.id, isOwner: 1 })
        },
    })

    /* const docUpload = [
        {
            type: 'uploadDropZone',
            name: 'userfile',
            titleText:
                props?.userDetails && props?.userDetails.domicile !== 'U.S. Citizen'
                    ? 'Upload PDF or JPG: Valid Passport'
                    : 'Upload PDF or JPG: Valid Driver’s License',
            innerText: '',
            class: `col-12 mt-0 ${formik.values.kyc_check_failed < 2 ? 'd-none' : ''}`,
            folder: folderName,
            multiple: false,
            accept: 'image/*, application/*',
            formik: documentFormik,
        },
        {
            label: 'Document Type',
            name: 'document_type',
            type: 'text',
            placeholder: 'Enter document type',
            class: `col-12 col-sm-6 ${formik.values.kyc_check_failed < 2 ? 'd-none' : ''}`,
            formik: documentFormik,
            upperLabel: true,
        },
    ] */

    const documentDetails = {
        formik: documentFormik,
        data: [
            {
                type: 'uploadDropZone',
                name: 'userfile',
                titleText:
                    props?.userDetails && props?.userDetails.domicile !== 'U.S. Citizen'
                        ? 'Upload PDF or JPG: Valid Passport'
                        : 'Upload PDF or JPG: Valid Driver’s License',
                innerText: '',
                //class: `col-12 mt-0 ${formik.values.kyc_check_failed < 2 ? 'd-none' : ''}`,
                class: `col-12 mt-0 ${
                    formik.values.kyc_check_failed >= 2 ||
                    (formik.values.domicile == 'non-resident' &&
                        formik.values.isDocumentUploaded === 0)
                        ? ''
                        : 'd-none'
                }`,
                folder: folderName,
                multiple: false,
                accept: 'image/*, application/*',
            },
            /* {
                label: 'Document Type',
                name: 'document_type',
                type: 'text',
                placeholder: 'Enter document type',
                class: `col-12 col-sm-6 ${formik.values.kyc_check_failed < 2 ? 'd-none' : ''}`,
                upperLabel: true,
            }, */
            {
                label: 'Document Type',
                name: 'document_type',
                type: 'select',
                placeholder: 'Select document type',
                //class: `col-12 col-sm-6 ${formik.values.kyc_check_failed < 2 ? 'd-none' : ''}`,
                class: `col-12 col-sm-6 ${
                    formik.values.kyc_check_failed >= 2 ||
                    (formik.values.domicile == 'non-resident' &&
                        formik.values.isDocumentUploaded === 0)
                        ? ''
                        : 'd-none'
                }`,
                upperLabel: true,
                options: [
                    { value: "Driver's License", show: "Driver's License" },
                    { value: 'Passport', show: 'Passport' },
                    { value: 'State ID Card', show: 'State ID Card' },
                ],
            },
        ],
    }

    const entityDocumentDetails = {
        formik: entityDocumentFormik,
        data: [
            {
                type: 'uploadDropZone',
                name: 'userfile0',
                titleText: 'Upload PDF or JPG: Valid Driver’s License',
                innerText: '',
                class: `col-12 mt-0 ${formik.values.kyc_check_failed < 2 ? 'd-none' : ''}`,
                folder: folderName,
                multiple: false,
                accept: 'image/*, application/*',
            },
            /* {
                type: 'uploadDropZone',
                name: 'userfile1',
                titleText: 'Upload PDF or JPG: Tax ID Letter (IRS EIN Paperwork)',
                innerText: '',
                class: 'col-12  px-0 mt-4',
                folder: folderName,
                multiple: false,
                accept: 'image/*, application/*',
            },
            {
                type: 'uploadDropZone',
                name: 'userfile2',
                titleText: 'Upload PDF or JPG: Valid Photo ID of Officer',
                innerText: '',
                class: 'col-12  px-0 mt-4',
                folder: folderName,
                multiple: false,
                accept: 'image/*, application/*',
            },
            {
                type: 'uploadDropZone',
                name: 'userfile3',
                titleText: 'Upload PDF or JPG: State Incorporation/Certification Document',
                innerText: '',
                class: 'col-12  px-0 mt-4',
                folder: folderName,
                multiple: false,
                accept: 'image/*, application/*',
            }, */
            {
                label: 'Document Type',
                name: 'document_type',
                type: 'text',
                placeholder: 'Enter document type',
                class: `col-12 col-sm-6 ${formik.values.kyc_check_failed < 2 ? 'd-none' : ''}`,
                formik: entityDocumentFormik,
                upperLabel: true,
            },
        ],
    }

    const editOwner = (owner) => {
        if (owner.id && owner.domicile != 'non-resident') {
            owner.ssn = owner.ssn
                ? owner.ssn.length > 9
                    ? Cryptos.decrypt(owner.ssn)
                    : owner.ssn
                : ''
        } else {
            owner.ssn = owner.ssn ? owner.ssn : ''
        }
        console.log('owner', owner)
        formik.setFieldValue('first_name', owner.first_name)
        formik.setFieldValue('last_name', owner.last_name)
        formik.setFieldValue('email', owner.email)
        formik.setFieldValue('phone', owner.phone)
        formik.setFieldValue('dob', owner.dob)

        formik.setFieldValue('ssn', owner.ssn)
        formik.values.ssn = owner.ssn
        formik.setFieldValue('address1', owner.address1)
        formik.setFieldValue('address2', owner.address2)
        formik.setFieldValue('city', owner.city)
        formik.setFieldValue('state', owner.state)
        formik.setFieldValue('id', owner.id)
        formik.setFieldValue('kyc_check_clicked', owner.kyc_check_clicked)
        formik.setFieldValue('kyc_check_failed', owner.kyc_check_failed)
        if (!owner.id && owner.unsavedID) {
            formik.setFieldValue('unsavedID', owner.unsavedID)
        }

        formik.setFieldValue('verified', owner.verified ? owner.verified : false)
        formik.setFieldValue('zip', owner.zip)
        //formik.setFieldValue('domesticYN', owner.domesticYN)
        formik.setFieldValue('domicile', owner.domicile)

        formik.setFieldValue('isDocumentUploaded', owner.isDocumentUploaded)

        setAddNew(true)

        documentFormik.resetForm()
    }

    const addMoreOwners = () => {
        formik.setFieldValue('first_name', '')
        formik.setFieldValue('last_name', '')
        formik.setFieldValue('email', '')
        formik.setFieldValue('phone', '+1')
        formik.setFieldValue('dob', '')
        formik.setFieldValue('ssn', '')
        formik.setFieldValue('address1', '')
        formik.setFieldValue('address2', '')
        formik.setFieldValue('city', '')
        formik.setFieldValue('state', '')
        formik.setFieldValue('id', '')
        formik.setFieldValue('kyc_check_clicked', 0)
        formik.setFieldValue('kyc_check_failed', 0)
        formik.setFieldValue('unsavedID', '')
        formik.setFieldValue('verified', false)
        formik.setFieldValue('zip', '')
        //formik.setFieldValue('domesticYN', '')
        formik.setFieldValue('domicile', '')
        formik.setFieldValue('isDocumentUploaded', 0)
        setAddNew(true)

        documentFormik.resetForm()
    }

    const submitOwners = () => {
        if (ownersList.length > 0) {
            let totalNew = ownersList.filter((elem) => {
                return !elem.id
            }).length
            let totalDeleted = ownersList.filter((elem) => {
                return elem.isDeleted
            }).length
            let totalEdited = ownersList.filter((elem) => {
                return elem.edited === 1
            }).length
            let totalOwners = 0
            ownersList.map((item, index) => {
                let noAlert = index == ownersList.length - 1 ? false : true
                let cryptedssn = ''

                if (item.domicile != 'non-resident') {
                    cryptedssn = item.ssn
                        ? item.ssn.length <= 9
                            ? Cryptos.encrypt(item.ssn)
                            : item.ssn
                        : ''
                } else {
                    cryptedssn = ''
                }

                let postData = {
                    first_name: item.first_name,
                    last_name: item.last_name,
                    email: item.email,
                    phone: item.phone,
                    dob: item.dob,
                    ssn: cryptedssn,
                    address1: item.address1,
                    address2: item.address2,
                    city: item.city,
                    state: item.state,
                    id: item.id,
                    kyc_check_clicked: item.kyc_check_clicked,
                    kyc_check_failed: item.kyc_check_failed,
                    edited: item.edited,
                    zip: item.zip,
                    domesticYN: item.domesticYN,
                    country: item.country,
                    domicile: item.domicile,
                }

                if (!item.id) {
                    totalNew--
                    addCompanyOwner(
                        postData,
                        totalNew > 1 ? true : false,
                        '',
                        item.documents ? item.documents : '',
                    )
                } else {
                    if (item.isDeleted) {
                        totalDeleted--
                        removeCompanyOwner(postData, totalDeleted > 1 ? true : false)
                    } else {
                        if (item.edited === 1) {
                            totalEdited--
                            updateCompanyOwner(postData, totalEdited > 1 ? true : false)
                        }
                        if (
                            item.kyc_check_failed >= 2 ||
                            (item.domicile == 'non-resident' && item.isDocumentUploaded === 0)
                        ) {
                            //uploadEntityDocument(item.documents)
                            if (item.documents && typeof item.documents !== 'undefined') {
                                uploadPartyDocument({ ...item.documents, domicile: item.domicile })
                            }
                        }
                    }
                }

                totalOwners++

                if (index >= ownersList.length - 1) {
                    setTimeout(() => {
                        props.loadCompanyOwners()
                    }, 1000)
                }
            })
            setDisableBtn(true)

            //getCompanyOwners()
            /* setTimeout(() => {
                props.loadCompanyOwners()
            }, 1000) */
        }
    }

    const confirmedDeleteOwner = () => {
        if (activeOwner && Object.keys(activeOwner).length) {
            let tmp = JSON.parse(JSON.stringify(ownersList))
            tmp.map((item, index) => {
                if (item.id != '' && item.id == activeOwner.id) {
                    item.isDeleted = true
                } else if (
                    item.unsavedID &&
                    item.unsavedID != '' &&
                    item.unsavedID == activeOwner.unsavedID
                ) {
                    tmp.splice(index, 1)
                }
            })
            setOwnersList(tmp)
            setConfirmDeleteOwner(false)
        }
    }

    const removeOwner = (owner) => {
        setActiveOwner(owner)
        setConfirmDeleteOwner(true)
        /* let tmp = JSON.parse(JSON.stringify(ownersList))
        tmp.map((item, index) => {
            console.log([item, owner])
            if (item.id != '' && item.id == owner.id) {
                item.isDeleted = true
            } else if (
                item.unsavedID &&
                item.unsavedID != '' &&
                item.unsavedID == owner.unsavedID
            ) {
                tmp.splice(index, 1)
            }
        })
        setOwnersList(tmp) */
    }

    useEffect(() => {
        if (!confirmDeleteOwner) {
            setActiveOwner([])
        }
    }, [confirmDeleteOwner])

    useEffect(() => {
        if (JSON.stringify(ownersList) != JSON.stringify(tmpOwnersList)) {
            setOwnersChanged(true)
            termformik.values.termCheck = 0
        } else {
            setOwnersChanged(false)
            if (ownersList.length > 0) {
                termformik.values.termCheck = 1
            } else {
                termformik.values.termCheck = 0
            }
        }
    }, [addNew, ownersList])

    useEffect(() => {
        props.ownersList.map((item, index) => {
            item.isDeleted = false
            /* item.verified = false

            if (
                (item.amlstatus === 'Approved' ||
                    item.amlstatus === 'Auto Approved' ||
                    item.amlstatus === 'Manually Approved') &&
                (item.kycstatus === 'Approved' ||
                    item.kycstatus === 'Auto Approved' ||
                    item.kycstatus === 'Manually Approved')
            ) {
                item.verified = true
            } */

            /*if (item.isDocumentUploaded && item.isDocumentUploaded === 1 && !partyDocumentLoaded) {
                setPartyDocumentLoaded(true)
                getuploadPartyDocument(
                    {
                        user_id: item.id,
                        page: 1,
                        limit: 20,
                        order: '',
                        orderby: '',
                        isOwner: 1,
                    },
                    true,
                )
            }*/
        })

        setOwnersList(props.ownersList)
        setTmpOwnersList(JSON.parse(JSON.stringify(props.ownersList)))
    }, [props.ownersList])

    useEffect(() => {
        setCircle(props.circle)
    }, [props.circle])

    useEffect(() => {
        if (responseStatusUser) {
            if (
                responseStatusUser.from == 'addCompanyOwner' ||
                responseStatusUser.from == 'updateCompanyOwner'
            ) {
                if (!responseStatusUser.noAlert) {
                    //props.loadCompanyOwners()
                }

                /* if (responseStatusUser.from == 'addCompanyOwner') {
                    console.log(responseStatusUser)
                    createNCUser(responseStatus.data.ownerID)
                } */
                setAddingOwner(false)
                //setAddNew(false)
                if (responseStatusUser.from == 'addCompanyOwner') {
                    if (
                        responseStatusUser.data &&
                        responseStatusUser.data.documents &&
                        typeof responseStatusUser.data.documents != 'undefined' &&
                        !responseStatusUser.data.documents.id &&
                        responseStatusUser.data.ownerID
                    ) {
                        responseStatusUser.data.documents.id = responseStatusUser.data.ownerID
                        uploadPartyDocument(responseStatusUser.data.documents)
                    }
                }
            } else if (responseStatusUser.from == 'removeCompanyOwner') {
                if (!responseStatusUser.noAlert) {
                    //props.loadCompanyOwners()
                }
            }
            setDisableBtn(false)
        }
    }, [responseStatusUser])

    useEffect(() => {
        if (formik.values.dob.length > 0 && calculateAge(formik.values.dob) < 18) {
            setAlert('Age must be 18+', 'error')
        }
    }, [formik.values.dob])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <div className="ownrDtlsWrpr">
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <h4 className="dashSubtitle">Company Owners</h4>
                    <Button className="bckToProfl" onClick={props.backFunction}>
                        <img src="/assets/svg/backarrow_blue.svg" className="mr-2" />
                        {props.backLabel ? props.backLabel : 'Back to Profile'}
                    </Button>
                </div>
                <p className="ownDtlsDescrp">
                    Due to regulatory requirements, we need to identify anyone who owns 20% or more
                    of the organization. This can include venture capitalists, investors, managing
                    directors, individual owners, etc.
                </p>
                {ownersList && ownersList.length ? (
                    <>
                        <div className="ownCardGrid">
                            {ownersList.map((owners, index) => (
                                <>
                                    <div
                                        className={`ownCard ${
                                            owners.verified
                                                ? 'verified'
                                                : owners.kyc_check_failed > 0
                                                ? 'unverified'
                                                : ''
                                        } ${owners.isDeleted ? 'd-none' : ''}`}
                                    >
                                        <p>
                                            {owners.first_name} {owners.last_name}
                                            {owners.verified ? (
                                                <span className="material-icons verifyIcon">
                                                    check_circle
                                                </span>
                                            ) : (
                                                <>
                                                    {owners.kyc_check_failed > 0 && (
                                                        <span className="material-icons unVerifyIcon">
                                                            cancel
                                                        </span>
                                                    )}
                                                </>
                                            )}
                                        </p>
                                        <div className="btnWrpr">
                                            <Button
                                                className="ownIcnBtn edtBtn"
                                                onClick={() => editOwner(owners)}
                                            >
                                                <span className="material-icons">edit</span>
                                            </Button>
                                            <Button
                                                className="ownIcnBtn dltBtn"
                                                onClick={() => removeOwner(owners)}
                                            >
                                                <span className="material-icons">delete</span>
                                            </Button>
                                        </div>
                                    </div>
                                </>
                            ))}
                        </div>
                    </>
                ) : (
                    <p className="ownDtlsDescrp text-center mt-2">No Owners Found.</p>
                )}

                <div
                    className="admreWrpr text-right w-100 mt-3"
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    {ownersList.length >= 5 ? (
                        <Tooltip title="Maximum company owners reached" placement="top-end">
                            <div>
                                <PrimaryButton
                                    onClick={() => addMoreOwners()}
                                    label={
                                        <>
                                            <span className="material-icons">person_add</span> Add
                                            more owners
                                        </>
                                    }
                                    disabled={true}
                                />
                            </div>
                        </Tooltip>
                    ) : (
                        <PrimaryButton
                            onClick={() => addMoreOwners()}
                            label={
                                <>
                                    <span className="material-icons">person_add</span> Add more
                                    owners
                                </>
                            }
                        />
                    )}
                </div>
                <div className="btmChkBxWrpr">
                    {mapData(checkbox)}
                    <div className="actnBtnws text-right w-100 mt-3">
                        <SecondaryButton
                            label={props.backLabel ? props.backLabel : 'Back to Settings'}
                            onClick={props.backFunction}
                        />
                        {!termformik.values.termCheck ? (
                            <Tooltip
                                title="Certification of Company Owners needs to be checked before you can Submit Owners"
                                placement="top"
                            >
                                <div>
                                    <PrimaryButton
                                        label="Submit Owners"
                                        disabled={
                                            !ownersChanged ||
                                            !termformik.values.termCheck ||
                                            disableBtn
                                        }
                                        onClick={() => submitOwners()}
                                    />
                                </div>
                            </Tooltip>
                        ) : (
                            <PrimaryButton
                                label="Submit Owners"
                                disabled={
                                    !ownersChanged || !termformik.values.termCheck || disableBtn
                                }
                                onClick={() => submitOwners()}
                            />
                        )}
                    </div>
                </div>
            </div>
            <FormDialog
                className="bidAskPopup prflAlrtPopup"
                open={addNew}
                openFunction={() => setAddNew(false)}
                maxWidth={'md'}
                title={
                    <div className="ttleCntnr d-flex align-items-center justify-content-between">
                        <h4 className="mb-0">{formik.values.id ? 'Edit' : 'Add'} Company Owner</h4>
                        <IconButton onClick={() => setAddNew(false)}>
                            <span className="material-icons">clear</span>
                        </IconButton>
                    </div>
                }
            >
                <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                    <div className="row text-left">{mapData(addOwner)}</div>
                    {/* {(formik.values.kyc_check_failed >= 2 ||
                        (formik.values.domicile == 'non-resident' &&
                            formik.values.isDocumentUploaded === 0) && (
                                <div className="row text-left">
                                    <div className="col-12 mt-4 mb-1">
                                        <label className="mb-0 cstmLable">Document</label>
                                    </div>
                                    {mapData(documentDetails)}
                                </div>
                            )} */}

                    {(formik.values.kyc_check_failed >= 2 && !formik.values.verified) ||
                    (formik.values.domicile == 'non-resident' &&
                        formik.values.isDocumentUploaded === 0) ? (
                        <>
                            <p style={{ color: '#B40123' }}>
                                Sorry, we were not able to verify your identity. Please upload a
                                valid ID, like a drivers license or passport. We will review the
                                information and get back to you ASAP to verify your identity.
                            </p>
                            <div className="row text-left">
                                <div className="col-12 mt-4 mb-1">
                                    <label className="mb-0 cstmLable">Document</label>
                                </div>
                                {mapData(documentDetails)}
                            </div>
                        </>
                    ) : (
                        ''
                    )}

                    <div className="btmBtns mt-3">
                        {formik.values.id ? (
                            <PrimaryButton type="submit" label="Edit" disabled={addingOwner} />
                        ) : (
                            <PrimaryButton type="submit" label="Add" disabled={addingOwner} />
                        )}
                    </div>
                </form>
            </FormDialog>

            <CustomDialog
                title={'Delete Owner'}
                open={confirmDeleteOwner}
                function={() => setConfirmDeleteOwner(false)}
            >
                <h5>Are you sure you want to delete this owner</h5>
                <div className="actionWrapper">
                    <Button onClick={() => setConfirmDeleteOwner(false)}>No</Button>
                    <PrimaryButton label="Yes" onClick={() => confirmedDeleteOwner()} />
                </div>
            </CustomDialog>
        </>
    )
}

export default OwnerDetails
